module.exports = {
	"genre": {
		"genre-id-1": "Divers",
		"genre-id-2": "Blues/Country/Folk",
		"genre-id-3": "Blues",
		"genre-id-4": "Country",
		"genre-id-5": "Folk",
		"genre-id-6": "Chanson française",
		"genre-id-7": "Interprètes de chanson française",
		"genre-id-8": "Chanson française rétro",
		"genre-id-9": "Rock français",
		"genre-id-10": "Classique",
		"genre-id-11": "Électronique ou concrète",
		"genre-id-12": "Musique concrète",
		"genre-id-13": "Musique électronique",
		"genre-id-14": "Musique minimaliste",
		"genre-id-15": "Mélodies & Lieder",
		"genre-id-16": "Lieder (Allemagne)",
		"genre-id-17": "Lieder",
		"genre-id-18": "Mélodies",
		"genre-id-19": "Mélodies (Angleterre)",
		"genre-id-20": "Mélodies (Europe du Nord)",
		"genre-id-21": "Mélodies (France)",
		"genre-id-22": "Musique concertante",
		"genre-id-23": "Autres instruments",
		"genre-id-24": "Concertos pour clavier",
		"genre-id-25": "Concertos pour violon",
		"genre-id-26": "Concertos pour violoncelle",
		"genre-id-27": "Musique de chambre",
		"genre-id-28": "Autres formations",
		"genre-id-29": "Autres instruments en solo",
		"genre-id-30": "Piano solo",
		"genre-id-31": "Quatuors",
		"genre-id-32": "Quintettes",
		"genre-id-33": "Duos",
		"genre-id-34": "Trios",
		"genre-id-35": "Violon solo",
		"genre-id-36": "Violoncelle solo",
		"genre-id-37": "Musique symphonique",
		"genre-id-38": "Ballets",
		"genre-id-39": "Musique de scène",
		"genre-id-40": "Musiques pour le cinéma",
		"genre-id-41": "Ouvertures",
		"genre-id-42": "Poèmes symphoniques",
		"genre-id-43": "Symphonies",
		"genre-id-44": "Musique vocale (profane et sacrée)",
		"genre-id-45": "Cantates (profanes)",
		"genre-id-46": "Musique chorale (pour chœur)",
		"genre-id-47": "Musique pour ensembles vocaux",
		"genre-id-48": "Oratorios profanes",
		"genre-id-49": "Récitals vocaux",
		"genre-id-50": "Musique vocale sacrée",
		"genre-id-51": "Cantates sacrées",
		"genre-id-52": "Chœurs sacrés",
		"genre-id-53": "Messes, Passions, Requiems",
		"genre-id-54": "Oratorios sacrés",
		"genre-id-55": "Opéra",
		"genre-id-56": "Extraits d'opéra",
		"genre-id-57": "Intégrales d'opéra",
		"genre-id-58": "Opérette",
		"genre-id-59": "Diction",
		"genre-id-60": "Pédagogie",
		"genre-id-61": "Documents historiques",
		"genre-id-62": "Humour",
		"genre-id-63": "Littérature",
		"genre-id-64": "Electronique",
		"genre-id-65": "Ambient",
		"genre-id-66": "Downtempo",
		"genre-id-67": "Drum & Bass",
		"genre-id-68": "House",
		"genre-id-69": "Lounge",
		"genre-id-70": "Techno",
		"genre-id-71": "Trance",
		"genre-id-72": "Trip Hop",
		"genre-id-73": "Enfants Ambiance",
		"genre-id-74": "Accordéon",
		"genre-id-75": "Contes et comptines",
		"genre-id-76": "Educatif",
		"genre-id-77": "Karaoké",
		"genre-id-78": "Musique militaire",
		"genre-id-79": "Relaxation",
		"genre-id-80": "Jazz",
		"genre-id-81": "Be Bop",
		"genre-id-82": "Cool jazz",
		"genre-id-83": "Free jazz & Avant-garde",
		"genre-id-84": "Gospel",
		"genre-id-85": "Jazz contemporain",
		"genre-id-86": "Jazz fusion & Jazz rock",
		"genre-id-87": "Jazz manouche",
		"genre-id-88": "Jazz traditionnel & New Orleans",
		"genre-id-89": "Jazz vocal",
		"genre-id-90": "Latin jazz",
		"genre-id-91": "Bandes originales",
		"genre-id-92": "Bandes originales de films",
		"genre-id-93": "Comédies musicales",
		"genre-id-94": "Musiques du monde",
		"genre-id-95": "Afrique",
		"genre-id-96": "Afrobeat",
		"genre-id-97": "Asie",
		"genre-id-98": "Bossa Nova & Brésil",
		"genre-id-99": "Celtique",
		"genre-id-100": "Europe de l'Est",
		"genre-id-101": "Fado",
		"genre-id-102": "Flamenco",
		"genre-id-103": "Musique ethnique",
		"genre-id-104": "Musique indienne",
		"genre-id-105": "Orient",
		"genre-id-106": "Raï",
		"genre-id-107": "Salsa",
		"genre-id-108": "Tango",
		"genre-id-109": "World Music",
		"genre-id-110": "Yiddish & Klezmer",
		"genre-id-111": "Zouk & Antilles",
		"genre-id-112": "Pop/Rock",
		"genre-id-113": "Alternatif et Indé",
		"genre-id-114": "Crooners",
		"genre-id-115": "Hard Rock",
		"genre-id-116": "Metal",
		"genre-id-117": "Pop",
		"genre-id-118": "Punk - New Wave",
		"genre-id-119": "Rock",
		"genre-id-120": "Rock progressif",
		"genre-id-121": "Rockabilly",
		"genre-id-122": "Variété internationale",
		"genre-id-123": "Reggae",
		"genre-id-124": "Dancehall",
		"genre-id-125": "Dub",
		"genre-id-126": "Ska & Rocksteady",
		"genre-id-127": "Soul/Funk/R&B",
		"genre-id-128": "Acid jazz",
		"genre-id-129": "Dance",
		"genre-id-130": "Disco",
		"genre-id-131": "Funk",
		"genre-id-132": "R&B",
		"genre-id-133": "Hip-Hop/Rap",
		"genre-id-134": "Soul",
		"genre-id-135": "Opérette",
		"genre-id-137": "Concertos pour trompette",
		"genre-id-138": "Concertos pour instruments à vent",
		"genre-id-139": "Crossover",
		"genre-id-140": "Documents",
		"genre-id-141": "New Age",
		"genre-id-142": "Ambiance",
		"genre-id-144": "Crossover",
		"genre-id-145": "Dixieland",
		"genre-id-146": "Ragtime",
		"genre-id-147": "Séries TV",
		"genre-id-148": "Jeux vidéo",
		"genre-id-149": "Latino",
		"genre-id-150": "Amérique du Nord",
		"genre-id-151": "Europe",
		"genre-id-152": "Gipsy",
		"genre-id-153": "Musique traditionnelle",
		"genre-id-154": "Maghreb",
		"genre-id-155": "Russie",
		"genre-id-156": "Turquie",
		"genre-id-157": "Pop indé",
		"genre-id-158": "Chansons paillardes",
		"genre-id-159": "Musiques de Noël",
		"genre-id-160": "Chanson allemande",
		"genre-id-161": "Ecosse",
		"genre-id-162": "Espagne",
		"genre-id-163": "Grèce",
		"genre-id-164": "Irlande",
		"genre-id-165": "Chanson italienne",
		"genre-id-166": "Portugal",
		"genre-id-167": "Enfants",
		"genre-id-176": "Musique vocale profane",
		"genre-id-173": "Schlager",
		"genre-id-171": "Stimmungsmusik",
		"genre-id-172": "Volksmusik",
		"genre-id-174": "Irish celtic",
		"genre-id-175": "Irish popmusic",
		"genre-id-168": "Musique folkloriquen Suisse",
		"genre-id-178": "Allemand",
		"genre-id-177": "Anglais",
		"genre-id-170": "Français",
		"genre-id-179": "Néerlandais"
	},
	"article-cat": {
		"article-cat-2": "-- ARCHIVES GÉNÉRALES --",
		"article-cat-4": "Rencontres",
		"article-cat-5": "-- ARCHIVES GER / LIRE / CLASSICA --",
		"article-cat-7": "Sur Scène",
		"article-cat-8": "Nominations et Prix",
		"article-cat-10": "Dans les médias",
		"article-cat-22": "Chers disparus",
		"article-cat-51": "Discographie",
		"article-cat-53": "Bibliographie",
		"article-cat-54": "Portraits",
		"article-cat-97": "Actualité",
		"article-cat-98": "Rubriques principales",
		"article-cat-100": "Industries",
		"article-cat-101": "Nouveautés",
		"article-cat-117": "JazzNews",
		"article-cat-122": "Vidéo du jour",
		"article-cat-189": "Interview",
		"article-cat-197": "Écoute comparée",
		"article-cat-199": "Rencontres",
		"article-cat-209": "J'ai la mémoire qui chante",
		"article-cat-226": "Cave Canem",
		"article-cat-227": "Fortissimo",
		"article-cat-229": "Peux-tu ?",
		"article-cat-238": "Magazine : critiques",
		"article-cat-252": "Callassotherapy",
		"article-cat-260": "Le symphoman",
		"article-cat-267": "Croisées",
		"article-cat-279": "Concerts",
		"article-cat-286": "Confidentiel",
		"article-cat-287": "Agenda",
		"article-cat-293": "Événements",
		"article-cat-295": "Concerts et tournées",
		"article-cat-297": "Hi-Fi",
		"article-cat-298": "Bancs d'essai",
		"article-cat-299": "Pratique",
		"article-cat-301": "Actualités",
		"article-cat-302": "Prises de son d'exception",
		"article-cat-303": "Les Magiciens du Son",
		"article-cat-304": "Trax",
		"article-cat-305": "De la vieille cire dans des oreilles propres",
		"article-cat-306": "Voxpop",
		"article-cat-311": "Orchestre Philharmonique de Berlin",
		"article-cat-312": "André Tubeuf : Mémoire et paysages",
		"article-cat-315": "François Hudry : Cum grano salis",
		"article-cat-316": "Qibuz Classique",
		"article-cat-318": "Les éditos",
		"article-cat-319": "Qobuz à",
		"article-cat-320": "Marseille",
		"article-cat-321": "Festival Paris Baroque",
		"article-cat-322": "Les cinglés de la Hi-Fi",
		"article-cat-323": "Rennes",
		"article-cat-324": "Éditoriaux",
		"article-cat-325": "Qibuz",
		"article-cat-326": "L'édito de Jean-Michel Proust",
		"article-cat-327": "Jean-Michel Proust : l'actu du mois",
		"article-cat-328": "Qibuz Lundi",
		"article-cat-329": "Lille",
		"article-cat-330": "Yes Masters !",
		"article-cat-331": "La Minute Qobuz",
		"article-cat-332": "Moderne",
		"article-cat-333": "Newsletters",
		"article-cat-334": "Newsletter Qobuz Hebdo",
		"article-cat-335": "Newsletter Promotions",
		"article-cat-336": "Newsletter Qobuz Hi-Fi",
		"article-cat-337": "Newsletter Classique",
		"article-cat-339": "Newsletter Electronique",
		"article-cat-340": "Newsletter Enfants",
		"article-cat-341": "Newsletter Diction",
		"article-cat-342": "Smartphones compatibles audio-HD",
		"article-cat-343": "Newsletter Chanson française",
		"article-cat-344": "France Musique",
		"article-cat-345": "Style Moderne",
		"article-cat-347": "Newsletter Ambiance",
		"article-cat-350": "En Anglais",
		"article-cat-351": "En Allemand",
		"article-cat-352": "En Neerlandais",
		"article-cat-353": "En Anglais",
		"article-cat-354": "En Allemand",
		"article-cat-355": "En Neerlandais",
		"article-cat-356": "En Neerlandais",
		"article-cat-357": "En Allemand",
		"article-cat-358": "En Anglais",
		"article-cat-359": "Vieux Sequins et Vieilles Cuirasses",
		"article-cat-360": "Hannah Krooz",
		"article-cat-361": "Qobuz & Vous",
		"article-cat-362": "Nouveautés Classiques",
		"article-cat-363": "Studio Qobuz",
		"article-cat-364": "Qobuz Studio",
		"article-cat-365": "À la une",
		"article-cat-366": "Trans Musicales 2019",
		"article-cat-368": "Archives",
		"article-cat-369": "Qobuz Chef",
		"article-cat-370": "One Cover / One Word"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/apiLocale/apiFr.json
// module id = 557
// module chunks = 0